<div class="shipping-concluded-wrapper">
  <div class="shipping-concluded">
    <div class="shipping-concluded__icon">
      <span class="pds-icon">{{ shipping | shippingStatus : 'icon' }}</span>
    </div>
    <h2 class="shipping-concluded__title">{{ shipping | shippingStatus : 'literal' }}</h2>
    <h3 class="shipping-concluded__description">{{ shipping.orderId }}</h3>
  </div>
  <ul class="shipping-concluded-proofs">
    @for (stop of shipping.stops; track $index) {
    @if (stop.finalized && (proofUrlFor(stop.index) || stop.receiverName)) {
    <li class="shipping-concluded-proofs__item">
      <h4 class="shipping-concluded-proofs__title">{{ stop | shippingStopKind : 'literal' }} — {{ stop.address }}</h4>
      @if (proofUrlFor(stop.index)) {
      <img class="shipping-concluded-proofs__photo" [src]="proofUrlFor(stop.index)" alt="Foto do comprovante" loading="lazy" />
      }
      @if (stop.receiverName) {
      <p class="shipping-concluded-proofs__receiver">Recebido por {{ stop.receiverName }}</p>
      }
    </li>
    }
    }
  </ul>
</div>
